// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ManifestoRouteImport } from './routes/manifesto'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AccountRouteRouteImport } from './routes/account/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnlinePokerIndexRouteImport } from './routes/online-poker/index'
import { Route as OnlinePokerStateRouteImport } from './routes/online-poker/$state'
import { Route as GameNewRouteImport } from './routes/game/new'
import { Route as GameIdRouteImport } from './routes/game/$id'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountWalletRouteImport } from './routes/account/wallet'
import { Route as OnlinePokerCountriesIndexRouteImport } from './routes/online-poker/countries/index'
import { Route as OnlinePokerCountriesCountryRouteImport } from './routes/online-poker/countries/$country'
import { Route as GameJoinIdRouteImport } from './routes/game/join/$id'
import { Route as OnlinePokerStateIndexRouteImport } from './routes/online-poker/$state/index'
import { Route as OnlinePokerStateCityRouteImport } from './routes/online-poker/$state/$city'
import { Route as OnlinePokerCountriesCountryIndexRouteImport } from './routes/online-poker/countries/$country/index'
import { Route as OnlinePokerCountriesCountryCityRouteImport } from './routes/online-poker/countries/$country/$city'

const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ManifestoRoute = ManifestoRouteImport.update({
            id: '/manifesto',path: '/manifesto',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AccountRouteRoute = AccountRouteRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const OnlinePokerIndexRoute = OnlinePokerIndexRouteImport.update({
            id: '/online-poker/',path: '/online-poker/',getParentRoute: () => rootRouteImport
          })
const OnlinePokerStateRoute = OnlinePokerStateRouteImport.update({
            id: '/online-poker/$state',path: '/online-poker/$state',getParentRoute: () => rootRouteImport
          })
const GameNewRoute = GameNewRouteImport.update({
            id: '/game/new',path: '/game/new',getParentRoute: () => rootRouteImport
          })
const GameIdRoute = GameIdRouteImport.update({
            id: '/game/$id',path: '/game/$id',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRouteRoute
          })
const AccountWalletRoute = AccountWalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => AccountRouteRoute
          })
const OnlinePokerCountriesIndexRoute = OnlinePokerCountriesIndexRouteImport.update({
            id: '/online-poker/countries/',path: '/online-poker/countries/',getParentRoute: () => rootRouteImport
          })
const OnlinePokerCountriesCountryRoute = OnlinePokerCountriesCountryRouteImport.update({
            id: '/online-poker/countries/$country',path: '/online-poker/countries/$country',getParentRoute: () => rootRouteImport
          })
const GameJoinIdRoute = GameJoinIdRouteImport.update({
            id: '/game/join/$id',path: '/game/join/$id',getParentRoute: () => rootRouteImport
          })
const OnlinePokerStateIndexRoute = OnlinePokerStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnlinePokerStateRoute
          })
const OnlinePokerStateCityRoute = OnlinePokerStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => OnlinePokerStateRoute
          })
const OnlinePokerCountriesCountryIndexRoute = OnlinePokerCountriesCountryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnlinePokerCountriesCountryRoute
          })
const OnlinePokerCountriesCountryCityRoute = OnlinePokerCountriesCountryCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => OnlinePokerCountriesCountryRoute
          })





const AccountRouteRouteChildren = {
  AccountWalletRoute: AccountWalletRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteRouteWithChildren = AccountRouteRoute._addFileChildren(AccountRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const OnlinePokerStateRouteChildren = {
  OnlinePokerStateCityRoute: OnlinePokerStateCityRoute,OnlinePokerStateIndexRoute: OnlinePokerStateIndexRoute
}

const OnlinePokerStateRouteWithChildren = OnlinePokerStateRoute._addFileChildren(OnlinePokerStateRouteChildren)




const OnlinePokerCountriesCountryRouteChildren = {
  OnlinePokerCountriesCountryCityRoute: OnlinePokerCountriesCountryCityRoute,OnlinePokerCountriesCountryIndexRoute: OnlinePokerCountriesCountryIndexRoute
}

const OnlinePokerCountriesCountryRouteWithChildren = OnlinePokerCountriesCountryRoute._addFileChildren(OnlinePokerCountriesCountryRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRouteRoute: AccountRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,LoginRoute: LoginRoute,ManifestoRoute: ManifestoRoute,SignupRoute: SignupRoute,GameIdRoute: GameIdRoute,GameNewRoute: GameNewRoute,OnlinePokerStateRoute: OnlinePokerStateRouteWithChildren,OnlinePokerIndexRoute: OnlinePokerIndexRoute,GameJoinIdRoute: GameJoinIdRoute,OnlinePokerCountriesCountryRoute: OnlinePokerCountriesCountryRouteWithChildren,OnlinePokerCountriesIndexRoute: OnlinePokerCountriesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)